export const count = new Intl.NumberFormat("en");

const ratio = new Intl.NumberFormat("en", {
  style: "percent",
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});

export const percent = (value: number | null | undefined) =>
  value == null ? "Unavailable" : ratio.format(value);

export const clamp = (value: number) => Math.min(1, Math.max(0, value));

/** Presentation bands shared with ISP Blocking Rate, not operational alarms. */
const RATE_OK = 0.7;
export const RATE_LOW = 0.4;

export function rateColor(value: number | null | undefined): string {
  if (value == null) return "text-muted";
  if (value >= RATE_OK) return "text-status-ok-text";
  if (value >= RATE_LOW) return "text-status-warn-text";
  return "text-status-error-text";
}
